import type { Scheduler } from '../types';

/**
 * Планировщик без батчинга.
 * Выполняет реакцию немедленно при каждом изменении источника данных.
 */
export const immediateScheduler: Scheduler = {
    schedule(execute) {
        execute();
    },
};
